<template>
  <el-card class="dictionary card-main">
   <div class="content">
     <div class="left">
       <div class="leftItem" :class="searchInfo.dicType === item.dicType ? 'isActive' : ''" v-for="(item, index) in dicTpyeList" :key="index" @click="searchData(item)">{{item.dicType}}{{item.dicTypeDesc ? '（' + item.dicTypeDesc + '）' : ''}}</div>
     </div>
     <div class="right">
       <el-form ref="searchInfo" :model="searchInfo" :inline="true" class="global-form">
         <el-form-item prop="dicType">
           <el-input v-model="searchInfo.dicType" placeholder="请输入字典分类" clearable></el-input>
         </el-form-item>
         <el-form-item prop="dicValue">
           <el-input v-model="searchInfo.dicValue" placeholder="请输入字典值" clearable></el-input>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
         </el-form-item>
       </el-form>
       <el-button type="primary"
         icon="el-icon-plus"
         @click="onAdd"
         class="mb20"
         v-show="$ButtonShow('SAAS_DICS_ADD_01')"
       >新增</el-button>
       <el-table class="global-table" stripe v-loading="tableData.loading" :data="tableData.data">
         <el-table-column
           :label="item.label"
           :prop="item.prop"
           :min-width="item.minWidth||''"
           :show-overflow-tooltip = "item.showOverflowTooltip||false"
           v-for="(item,index) in tableData.tr"
           :key="index">
         </el-table-column>
         <el-table-column label="操作" width="160px" fixed="right">
           <template v-slot="{ row }">
             <template>
               <el-button type="text" @click="onUpdate(row.dicId)" v-show="$ButtonShow('SAAS_DIC_EDT_01')">编辑</el-button>
             </template>
           </template>
         </el-table-column>
       </el-table>
       <GlobalPagination
         @current-change="getDicList"
         @size-change="getDicList"
         :current-page.sync="page"
         :page-size.sync="size"
         :total="total">
       </GlobalPagination>
     </div>
   </div>
   <el-dialog :title="title" :visible.sync="dialogFormVisible" width='500px' class="dialog" :close-on-click-modal='false' destroy-on-close>
     <el-form ref="info" :model="info" label-width="80px" :rules="rules">
       <el-form-item label="字典分类" prop='dicType'>
         <el-select v-model="info.dicType"  placeholder="请选择字典分类" style='width: 380px;'>
           <el-option
             v-for="item in dicTpyeList"
             :key="item.dicType"
             :label="item.dicType"
             :value="item.dicType"
           ></el-option>
         </el-select>
       </el-form-item>
       <el-form-item label="字典编码" prop='dicCode' >
         <el-input v-model="info.dicCode" :disabled="title === '编辑字典'" maxlength="10" placeholder='请输入字典编码'>
         </el-input>
       </el-form-item>
       <el-form-item label="字典值" prop='dicValue'>
         <el-input v-model="info.dicValue" placeholder='请输入字典值'>
         </el-input>
       </el-form-item>
       <el-form-item label="排序" prop='orderNum'>
         <el-input v-model="info.orderNum" placeholder='请输入排序'>
         </el-input>
       </el-form-item>
       <el-form-item>
         <el-button type="primary" @click='submitForm()' :disabled="submitShow">确认
         </el-button>
         <el-button @click='dialogFormVisible=false'>取消</el-button>
       </el-form-item>
     </el-form>
   </el-dialog>
 </el-card>
</template>

<script>
import { pInteger } from '@/utils/validate'
export default {
  name: 'dictionaryList',
  data () {
    return {
      dicTpyeList: [],
      props: {
        value: 'deptId',
        label: 'deptName',
        children: 'childNode'
      },
      dialogFormVisible: false,
      title: '新增组织',
      info: {
        dicType: '',
        dicCode: '',
        dicValue: '',
        orderNum: ''
      },
      rules: {
        dicType: [{ required: true, message: '请输入字典分类', trigger: ['blur'] }],
        dicCode: [{ required: true, message: '请输入字典编码', trigger: ['blur'] }],
        dicValue: [{ required: true, message: '请输入字典值', trigger: ['blur'] }],
        orderNum: [
          { required: true, message: '请输入排序', trigger: ['blur'] },
          { validator: pInteger, trigger: ['blur', 'change'] }
        ]
      },
      submitShow: false,
      searchInfo: {
        dicType: '',
        dicValue: ''
      },
      tableData: {
        loading: false,
        tr: [
          {
            label: '字典分类',
            prop: 'dicType',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '字典编码',
            prop: 'dicCode',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '字典值',
            prop: 'dicValue',
            minWidth: '120',
            showOverflowTooltip: true
          },
          {
            label: '排序',
            prop: 'orderNum',
            minWidth: '100',
            showOverflowTooltip: true
          }
        ],
        data: [{}]
      },
      total: 0,
      page: 1,
      size: 10
    }
  },
  created () {
    this.getDicTypeList()
    this.getDicList()
  },
  methods: {
    getDicTypeList () {
      this.$axios.get(this.$apis.system.selectDicTypeByList).then((res) => {
        this.dicTpyeList = res || []
      })
    },
    searchData (item) {
      this.searchInfo.dicType = item.dicType
      this.onSearch()
    },
    submitForm () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.submitShow = true
          const url = this.info.dicId
            ? this.$apis.system.updateDic
            : this.$apis.system.insertDic
          this.$axios.post(url, this.info).then(() => {
            this.$message.success('保存成功')
            this.getDicList()
            this.dialogFormVisible = false
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },
    // 数据项列表数据请求
    getDicList () {
      this.tableData.loading = true
      this.$axios.get(this.$apis.system.selectDicByPage, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.tableData.loading = false
        this.tableData.data = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.tableData.loading = false
      })
    },
    onSearch () {
      this.page = 1
      this.getDicList()
    },
    onAdd () {
      this.title = '新增字典'
      this.dialogFormVisible = true
      this.info = {
        dicType: this.searchInfo.dicType || '',
        dicCode: '',
        dicValue: '',
        orderNum: ''
      }
    },
    onUpdate (dicId) {
      this.title = '编辑字典'
      this.getDicDetail(dicId)
    },
    getDicDetail (dicId) {
      this.$axios.get(this.$apis.system.selectDicByDicId, {
        dicId: dicId
      }).then((res) => {
        this.info = res
        this.dialogFormVisible = true
      })
    }
  }
}
</script>

<style scoped lang='scss'>

.dictionary{
 ::v-deep .el-card__body {
   height: 100%;
   padding: 0px !important;
 }
 .content {
   height: 100%;
   display: flex;
   justify-content: space-between;
   .left{
     width: 300px;
     height: calc(100% - 40px);
     overflow-y: auto;
     background: #F6F8FB;
     padding: 15px;
     margin: 20px;
     box-shadow: 0px 1px 2px 0px rgba(139,172,237,0.1);
     border-radius: 10px;
     .leftItem {
       width: 100%;
       height: 32px;
       border-radius: 20px;
       padding: 5px 20px;
       font-size: 14px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       line-height: 22px;
       margin: 10px 0;
       color: #000517;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       cursor: pointer;
       &:hover {
         background: #E5E4FF;
         box-shadow: 0px 2px 4px 0px #E5E4FF;
       }
       &.isActive {
         background: var(--color-primary);
         color: #FFFFFF;
         box-shadow: 0px 2px 4px 0px #E5E4FF;
       }
     }
   }
   .right{
     width: calc(100% - 320px);
     height: 100%;
     padding: 20px;
     border-left: 1px solid #F4F4F4;
   }
 }
}

</style>
